import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      "#B3B3B3",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === "light" ? "#14AE5C" : "#308fe8",
  },
}));

function LinearProgressWithLabel(props) {
  const { value, ...other } = props;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        
        <BorderLinearProgress  variant="determinate" {...other} sx={{ '& .MuiLinearProgress-bar': { backgroundColor: '#14AE5C' }, }} value={value} />
      </Box>
      <Box sx={{ minWidth: 45 }}>
        <Typography variant="body2" color="text.secondary">{`${Math.round(
          props.value,
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};

// Inspired by the former Facebook spinners.

export default function CustomizedProgressBars(props) {
    return (
        <Box sx={{ flexGrow: 1 }}>
            <LinearProgressWithLabel variant="determinate" value={props.progress} />
        </Box>
    );
}
